import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel"];

  connect() {
    this.boundOnDocumentClick = this.onDocumentClick.bind(this);
    this.boundOnEscape = this.onEscape.bind(this);
    this.boundOnOtherOpen = this.onOtherOpen.bind(this);
  }

  disconnect() {
    this.removeListeners();
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    this.isOpen ? this.close() : this.open();
  }

  open() {
    document.dispatchEvent(
      new CustomEvent("filter-dropdown:open", { detail: { source: this.element } })
    );
    this.panelTarget.classList.remove("hidden");
    this.element.dataset.open = "true";
    document.addEventListener("click", this.boundOnDocumentClick);
    document.addEventListener("keydown", this.boundOnEscape);
    document.addEventListener("filter-dropdown:open", this.boundOnOtherOpen);
  }

  close() {
    this.panelTarget.classList.add("hidden");
    delete this.element.dataset.open;
    this.removeListeners();
  }

  removeListeners() {
    document.removeEventListener("click", this.boundOnDocumentClick);
    document.removeEventListener("keydown", this.boundOnEscape);
    document.removeEventListener("filter-dropdown:open", this.boundOnOtherOpen);
  }

  get isOpen() {
    return this.element.dataset.open === "true";
  }

  onDocumentClick(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  onEscape(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  onOtherOpen(event) {
    if (event.detail.source !== this.element) {
      this.close();
    }
  }
}
